module.exports = __webpack_public_path__ + "img/close.aec248a9.svg";